import React from "react";
import { useContent } from "@/context/ContentContext";
import { useLang } from "@/context/LanguageContext";

const AnnouncementBar = () => {
  const content = useContent();
  const { lang } = useLang();
  const a = content?.announcement;
  if (!a || !a.enabled) return null;
  const text = (lang === "ro" ? a.ro : a.en) || "";
  return (
    <div className="w-full bg-foreground py-1.5 px-3 text-center" data-testid="announcement-bar">
      <span className="font-mono text-[8px] leading-tight uppercase tracking-widest text-white sm:text-[10px]">{text}</span>
    </div>
  );
};

export default AnnouncementBar;
